import vars from '../helpers';

const init = () => {
	if (vars.isMobile()) {
		return;
	}

	const $cursor = $('.cursor');

	vars.$document.on('mousemove', (e) => {
		let x = e.clientX;
		let y = e.clientY;

		$cursor.css({
			left: `${x}px`,
			top: `${y}px`,
		});
	});

	let isEnter = false;
	let isEnterGoesOn = false;

	const $hover = $('.js-hover');

	$hover.on('mouseenter', () => {
		if (!isEnter) {
			const tl = gsap.timeline();

			tl
				.to($cursor, {
					onStart() {
						isEnter = true;
						isEnterGoesOn = true;
					},
					duration: 0.4,
					width: '25px',
					// scale: '1.15',
				}, 0)
				.to($cursor, {
					onComplete() {
						isEnterGoesOn = false;
					},
					duration: 1,
					width: '11px',
					// scale: '0.5',
				}, 0.4)
			;
		}
	});

	$hover.on('mouseleave', () => {
		const tl = gsap.timeline();

		tl
			.to($cursor, {
				onComplete() {
					isEnter = false;
				},
				duration: 0.4,
				width: '22px',
				// scale: '1',
			}, isEnterGoesOn ? 1 : 0);
	});
};

export default {
	init,
};
